package fr.frux.navigation

import fr.frux.core.maps.MapCameraPosition

/** Lien reçu par la plateforme hôte à chaud (App Links Android). [id] change à chaque réception. */
data class AppLink(
    val path: String,
    val search: String,
    val id: Long,
)

/** Décision commune aux plateformes, testable sans Android. */
sealed interface AppLinkAction {
    data class Open(
        val route: Route,
    ) : AppLinkAction

    /** `/carte`, [view] nulle quand la query manque ou est invalide. */
    data class ShowMap(
        val view: MapCameraPosition?,
    ) : AppLinkAction

    data object Ignore : AppLinkAction
}

/**
 * Seules les destinations déclarées dans l'intent-filter sont suivies : `adb` peut envoyer
 * n'importe quelle URI à l'activité, une route privée (profil, réglages) n'a pas à s'ouvrir par là.
 */
fun AppLink.toAction(): AppLinkAction =
    if (path.trimEnd('/') == "/carte") {
        AppLinkAction.ShowMap(parseMapViewQuery(search))
    } else {
        when (val route = parseUrlPath(path)) {
            is Route.TreeDetail, is Route.SiteDetail -> AppLinkAction.Open(route)
            else -> AppLinkAction.Ignore
        }
    }
